export default __webpack_public_path__ + "static/media/kids.fc8cc47a.jpg";